import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import Footer from '../../../../components/home_page/Footer'
import { closeModal } from '../../../../redux/actions/action-creator'
import { useDispatch } from 'react-redux'
import { getVoucherDate } from '../../../../components/Date_Formate_Utilitiy/Index'

const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Month name → 1-based number (case-insensitive, supports full names and abbreviations)
const MONTH_NAME_MAP = {
    jan: 1, january: 1,
    feb: 2, february: 2,
    mar: 3, march: 3,
    apr: 4, april: 4,
    may: 5,
    jun: 6, june: 6,
    jul: 7, july: 7,
    aug: 8, august: 8,
    sep: 9, sept: 9, september: 9,
    oct: 10, october: 10,
    nov: 11, november: 11,
    dec: 12, december: 12,
};

/**
 * Parse a month token that may be a number ("4") or a name ("Apr" / "April").
 * Returns 1-based month number, or null if unrecognised.
 */
const parseMonth = (token) => {
    // Legacy function - kept for compatibility if needed elsewhere, 
    // but we use getVoucherDate now.
    const asNum = parseInt(token, 10);
    if (!isNaN(asNum)) return asNum;
    return MONTH_NAME_MAP[token.toLowerCase()] || null;
};

const Period = (props) => {
    const dispatch = useDispatch();
    const [voucherDate, setVoucherDate] = useState({ from: props?.data?.create_date || '', to: '' });
    const from_input_ref = useRef(null);
    const { company_session } = useSelector(state => state.common);

    const financialYearStart = new Date(company_session?.start_financial_year).getFullYear();
    const financialYearEnd = new Date(company_session?.end_financial_year).getFullYear();

    /**
     * Validate day/month/year and, if valid, push the formatted date to parent state
     * then close the modal.
     */
    const applyDate = (dayStr, parsedMonth, parsedYear) => {
        if (!parsedMonth || parsedMonth < 1 || parsedMonth > 12) {
            alert('Invalid month. Use a number (1–12) or a name (Jan, February…)');
            return;
        }
        const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate();
        const parsedDay = parseInt(dayStr, 10);
        if (isNaN(parsedDay) || parsedDay < 1 || parsedDay > daysInMonth) {
            alert('Invalid day for the given month');
            return;
        }

        const monthAbbreviation = MONTH_ABBR[parsedMonth - 1];
        const formattedDateString = `${String(parsedDay).padStart(2, '0')}-${monthAbbreviation}-${parsedYear}`;
        const dayObj = new Date(formattedDateString);
        const day_show = dayObj.toLocaleString('en-US', { weekday: 'long' });

        setVoucherDate(prev => ({ ...prev, from: formattedDateString }));
        props.setData({ ...props.data, create_date: formattedDateString, day_name: day_show });
        dispatch(closeModal('period'));
    };

    const handlechange = (e) => {
        const { name, value } = e.target;
        setVoucherDate(prev => ({ ...prev, [name]: value }));

        if (name === 'from' && e?.key === 'Enter') {
            e.preventDefault();
            const input = voucherDate.from.trim();
            if (!input) return;

            const dateResult = getVoucherDate(input, company_session, props.data?.create_date);

            if (dateResult && dateResult.formattedDateString) {
                setVoucherDate(prev => ({ ...prev, from: dateResult.formattedDateString }));
                props.setData({
                    ...props.data,
                    create_date: dateResult.formattedDateString,
                    day_name: dateResult.day_show
                });
                dispatch(closeModal('period'));
            } else {
                alert('Invalid date. Use formats like: 15, 1-4, 1-Apr, 1-4-2025, 01-Apr-2025');
            }
        }
    };

    useEffect(() => {
        const handlekeydown = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                dispatch(closeModal('period'));
                e.stopPropagation();
            }
            if (e.ctrlKey && (e.key === 'a' || e.key === 'A')) {
                e.preventDefault();
                e.stopPropagation();
                // Trigger the same logic as Enter
                handlechange({ target: { name: 'from', value: voucherDate.from.trim() }, preventDefault: () => { }, key: 'Enter' });
            }
        };
        document.addEventListener('keydown', handlekeydown);
        return () => {
            document.removeEventListener('keydown', handlekeydown);
        };
    }, [props.data, voucherDate]);

    const { from } = voucherDate;

    return (
        <div className='my-card'>
            <div className='cross_button' onClick={() => dispatch(closeModal('period'))}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </div>
            <div className='container pb-3 border border-dark' id='card-period'>
                <div className='row'>
                    <div className='col'>
                        <b className='border-bottom'>Voucher Date</b>
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <div className='d-flex justify-content-between align-item-center'>
                            <label className='lab-1'>Date of Voucher</label>
                            <label>:</label>
                            <input
                                type='text'
                                autoFocus
                                name='from'
                                id='from'
                                ref={from_input_ref}
                                onChange={handlechange}
                                onKeyUp={handlechange}
                                value={from || ''}
                                placeholder='e.g. 1-Apr or 1-4-2025'
                                className='lab-right'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='tomasterfooter' style={{ background: 'red' }}><Footer /></div>
        </div>
    );
};

export default Period;